import { keys, pick, first, last } from "underscore";

export function getAllAllowedTermsMap(amount) {
    amount = parseInt(amount, 10);

    if ($('body').hasClass('restricted')) {
        return {
            12: amount <= 7500,
            18: amount >= 1000,
            24: amount >= 1000,
            36: amount >= 1000,
            48: amount > 2500,
            60: amount > 2500,
        };     
    }
    return {
        3: amount <= 1000,
        6: amount <= 2000,
        12: amount <= 7500,
        18: amount >= 1000,
        24: amount >= 1000,
        36: amount >= 1000,
        48: amount > 2500,
        60: amount > 2500,
    };
}

export function getDropDownTerms() {
    if ($('body').hasClass('restricted')) {
        return {
            "12": "12 Months",
            "18": "18 Months",
            "24": "24 Months",
            "36": "36 Months",
            "48": "48 Months",
            "60": "60 Months",
        };     
    }
    return {
        "3": "3 Months",
        "6": "6 Months",
        "12": "12 Months",
        "18": "18 Months",
        "24": "24 Months",
        "36": "36 Months",
        "48": "48 Months",
        "60": "60 Months",
    };
}

export function getAllowedTermsArray(amount) {
    amount = parseInt(amount, 10);
    return keys(
        pick(
            getAllAllowedTermsMap(amount),
            function (value) {
                return value;
            }
        )
    );
}

export function getClosestAllowedTerm(amount, term) {
    amount = parseInt(amount, 10);
    term = parseInt(term, 10);
    var termsArray = getAllowedTermsArray(amount);
    let firstTerm = first(termsArray);
    let lastTerm = last(termsArray);
    
    if (!term || term < firstTerm) {
        return firstTerm;
    } else if (term > lastTerm) {
        return lastTerm;
    }
    return null;
}

export function shouldSetDefaultTerm() {
    const urlParams = new URLSearchParams(window.location.search);
    const defaultTrmParameter = urlParams.get('useDefaultTerm');
    if (defaultTrmParameter === 'true') {
        return 'true';
    }
    return 'false';
}

export function setLoanTerm(loanAmount) {
    let targetTermValue;
    let shouldSetDefault = shouldSetDefaultTerm();
    if (shouldSetDefault !== 'true') { 
        return;
    }
    if (loanAmount <= 500) {
        targetTermValue = 3;
    }
    if (loanAmount > 500 && loanAmount <= 1000) {
        targetTermValue = 6;
    }
    if (loanAmount > 1000 && loanAmount <= 2000) {
        targetTermValue = 12;
    }
    if (loanAmount > 2000 && loanAmount <= 4000) {
        targetTermValue = 24;
    }
    if (loanAmount > 4000 && loanAmount <= 10000) {
        targetTermValue = 36;
    }
    
    return targetTermValue;
}